import React from 'react';

import ExpansionPanel from "@material-ui/core/ExpansionPanel";
import ExpansionPanelDetails from "@material-ui/core/ExpansionPanelDetails";
import ExpansionPanelSummary from "@material-ui/core/ExpansionPanelSummary";
import Typography from "@material-ui/core/Typography";
import { withStyles } from '@material-ui/core/styles';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';

const styles = theme => ({
  expansionPanelSummaryContent: {
    minWidth: '0'
  },
  expansionPanelSummaryText: {
    paddingLeft: theme.spacing (2),
    paddingRight: theme.spacing (2),
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis'
  }
});

function ToolPanel (props) {
  const {
    classes,
    title,
    tag,
    children,
    ...other
  } = props;

  const tags =
    new Set (window.location.hash ? window.location.hash.substring (1).split (',') : []);

  return (
    <ExpansionPanel defaultExpanded={tags.has (tag)}
                    onChange={(event, expanded) => {
                      const tags =
                        new Set (window.location.hash ? window.location.hash.substring (1).split (',') : []);

                      if (expanded) tags.add (tag);
                      else tags.delete (tag);

                      window.location.hash = [ ...tags ].join (',');
                    }}
                    {...other}>
      <ExpansionPanelSummary expandIcon={<ExpandMoreIcon />}
                             classes={{content: classes.expansionPanelSummaryContent}}>
        <Typography variant="body1" className={classes.expansionPanelSummaryText}>
          {title}
        </Typography>
      </ExpansionPanelSummary>
      <ExpansionPanelDetails>
        {children}
      </ExpansionPanelDetails>
    </ExpansionPanel>
  );
}

export default withStyles (styles) (ToolPanel);
